import { mutation } from "./mutation"

export const fetching = {
	mutation,
}
